import * as React from 'react'
import { Switch, Link } from 'react-router-dom'
import { Menu, Layout } from 'antd'
import routes from './router'
import './index.css'

const { Sider } = Layout

class Personal extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      selectedKeys: null,
    }
  }

  UNSAFE_componentWillMount() {
    this.setSiderSelected()
  }

  UNSAFE_componentWillReceiveProps() {
    this.setSiderSelected()
  }

  /**
   * 设置左侧子菜单选中
   */
  setSiderSelected = () => {
    // 获取当前url
    let currentPage = '1'
    if (window.location.href.indexOf('/personal/account') < 0) {
      currentPage = '2'
    }

    this.setState({
      selectedKeys: [currentPage],
    })
  }

  render() {
    return (
      <React.Fragment>
        <div className="top-img service">
          <img src="/img/personal-top-img.png" alt="" />
        </div>
        <div className="index-content">
          <div className="person-info">
            <div className="person-content">
              <Sider trigger={null} width={184} className="person-silder">
                <Menu
                  key="subMenu"
                  mode="inline"
                  selectedKeys={this.state.selectedKeys}
                >
                  <Menu.Item key={1}>
                    <Link to={'/personal/account'}>账户中心</Link>
                  </Menu.Item>
                  <Menu.Item key={2}>
                    <Link to={'/personal/trade'}>交易明细</Link>
                  </Menu.Item>
                  {/* <Menu.Item key={2}>
                    <Link to={'/personal/report'}>报告中心</Link>
                  </Menu.Item> */}
                </Menu>
              </Sider>
              {/* </div> */}
              <div className="content">
                <Switch>{routes}</Switch>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    )
  }
}

export default Personal
